import { render, staticRenderFns } from "./ReportImageCockpitDetail.vue?vue&type=template&id=493d086b"
import script from "./ReportImageCockpitDetail.vue?vue&type=script&lang=ts"
export * from "./ReportImageCockpitDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageCockpitDetail.vue?vue&type=style&index=0&id=493d086b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports